import React from 'react';
import {useSelector, useDispatch} from 'react-redux'
import TextField from '@material-ui/core/TextField';
import { isEmpty } from 'lodash';
import {onGetMinaChild,getChildKontoUsers,
    getOrderStatusListbyAfid
} from 'actions'
import IntlMessages from 'util/IntlMessages';
function MinaBarnList(props) {
    const dispatch = useDispatch()
    const Afid = useSelector(state => state.auth.authUser.user_Afid)
    const userid = useSelector(state => state.auth.authUser.user_id)
    const ChildList = useSelector(state => state.accountsData.ChildList)
    const Kontonamn = useSelector(state => state.accountsData.currentAccount.name)
    const [SelectedBarn,setSelectedBarn]=React.useState(0)
    React.useEffect(()=>{
        dispatch(onGetMinaChild(Afid))
        dispatch(getOrderStatusListbyAfid(Afid,1))
    },[])
    const onChangeBarn=(e)=>{
        let BarnId = e.target.value
        setSelectedBarn(BarnId)
        dispatch(getChildKontoUsers(Afid,userid,BarnId))
        let Meta = "Konton"
        props.handleChange(Meta,BarnId)  
        
        dispatch(getOrderStatusListbyAfid(BarnId,1))
    }
    return (
        <div>
        {
             isEmpty(ChildList)?"":
             <form>
             <div style={{ height: 'auto', paddingTop: '10px' }}>
                 <TextField
                 select
                 label={<IntlMessages id="Account"/>}
                 variant="outlined"
                 size="small"
                 value={SelectedBarn}
                 fullWidth
                 onChange={onChangeBarn}
                 SelectProps={{
                     native: true,
                 }}
                 >
                     <option key="0" disabled  value={0}><IntlMessages id="Choose"/></option>
                     <option key={Afid} value={Afid}>{Kontonamn}</option>
                     {
                         isEmpty(ChildList)?[]:
                         ChildList.map((option,index) => (
                             <option key={index} value={option.ChildAfid}>
                                 {option.name}
                             </option>
                     ))}
     </TextField>
 </div>
</form>
        }  
        </div>
    );
}

export default MinaBarnList;